import { Modify } from "@biblioteksentralen/types";
import { Button as ChakraButton, ButtonProps as NativeButtonProps } from "@chakra-ui/react";
import { ComponentWithAs } from "@chakra-ui/system";
import { CustomButtonVariants } from "../styles/chakraTheme/ButtonStyles";

/**
 * Re-exporting chackras Button with a customised types
 * This causes both chakras native variants and our home-made variants to show up in auto-complete
 */
type ButtonVariants = NativeButtonProps["variant"] | CustomButtonVariants;
export type ButtonBSProps = Modify<NativeButtonProps, { variant?: ButtonVariants }>;
export const ButtonBS = ChakraButton as ComponentWithAs<"button", ButtonBSProps>;
